
import DesktopGallery from "@/sliders/desktopSlider"
import MobileSlider from "@/sliders/mobileSlider"

// Logic
// import isABTestActive from "@/logic/isABTestActive"

// Config
import {galleryFeature} from "@/config/ABTestFeatures"
import { galleryActive } from '@/config/ABTestExperiments';
import { getVirtualTourUrl } from "@/config/virtualTourUrls";

// Cookies
import Cookies from "js-cookie";


export default async () => {
  // gallery

  // HIDE SSR GALLERY ON MOBILE

  document.querySelector("section.tf-gallerie").classList.add("d-none")

  document.querySelector("section.tf-gallerie").classList.add("d-md-block")


  // GET SOURCE OBJECTS (objects from SSR that contain src's to images of different resolutions, e.g. imgSmall, imgMedium, imgLarge, imgXL, etc.)
  // For more information, check this documentation: https://travelfactory.atlassian.net/wiki/spaces/TA/pages/2766929939/Images+Flow

  let srcObjectArray = [];

  let liheImages = []
  if (window.seasonManager.isWinter()) {
    liheImages = window.lihe["picturesLodgingWinter"] || window.lihe["picturesLodging"]
  } else if (window.seasonManager.isSummer()) {
    liheImages = window.lihe["picturesLodgingSummer"] || window.lihe["picturesLodging"]
  } else {
    throw new Error("season in hash is mandatory, make sure the decideSeason function runs before this")
  }

  const prestImageArrays = window.lihe.prestations.map((prestObj => prestObj.picturesAccomodation))
  const prestImages = prestImageArrays.flat()
  const srcObjectArrayWithAllImages = [...liheImages, ...prestImages]




  // Removing duplicated images
  let set = new Set();
  for (let obj of srcObjectArrayWithAllImages) {
    // Convert the object to a string to use as the Set key
    const objStr = JSON.stringify(obj);
    
    // If the object hasn't been added to the Set yet, add it to the unique array
    if (!set.has(objStr)) {
      set.add(objStr);
      srcObjectArray.push(obj);
    }
  }

  // add types to images
  srcObjectArray = srcObjectArray.map((obj => {
    return {
      ...obj,
      type: 'image'
    }
  }))


  // insert youtube video into source objects array
  const indexOfYoutubeVideo = 2
  if (window.lihe.id_youtube_ts) {
    const obj = {
      type: "video_youtube",
      src: window.lihe.id_youtube_ts
    }
    if (srcObjectArray.length <= indexOfYoutubeVideo) {
      srcObjectArray.push(obj)
    } else {
      srcObjectArray.splice(indexOfYoutubeVideo, 0, obj)
    }
  }

  window.srcObjectArray = srcObjectArray
  window.liheImages = liheImages
  window.prestImages = prestImages


  const event = new CustomEvent('openResidenceGallery');
  if (window.screenSizeManager.screenType!=='desktop') {
    window.gallerySliderMobile = new MobileSlider(
      window.srcObjectArray, undefined, "#tf-gallerie-slider-mobile"
    )
    window.gallerySliderMobile.init()
    const element = document.getElementById("slider-list-container")
    element.addEventListener('click', () => {
      window.dispatchEvent(event);
    })
  } else {
    // selectors of elements that on click should open the gallery
    const activatingSelectors = [".gallery-tile .gallery-img", "#tf-see-all-photos"]
    Array.from(activatingSelectors).forEach((activatingSelector) => {
      const elems = document.querySelectorAll(activatingSelector)
      elems.forEach((elem) => {
        elem.addEventListener('click', () => {
          window.dispatchEvent(event);
        })
      })
    })
  }

  window.addEventListener("availableImagesBuilt", () => {
    const isMobile = window.screenSizeManager.screenType !=='desktop'
    if(!isMobile && window.gallerySliderDesktop) {
      window.gallerySliderDesktop.srcObjectArray = window.srcObjectArray
    }
  })

  addVirtualTourBtn()
}

const VIRTUAL_TOUR_360_ICON = `
  <svg class="tf-virtual-tour__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M5.8841 14.1322C4.7985 14.1322 4.22931 13.6573 3.80902 12.922L5.07744 11.9722C5.26214 12.2427 5.46192 12.4571 5.87467 12.4571C6.28743 12.4571 6.53055 12.1686 6.53055 11.8239C6.53055 11.4612 6.32135 11.1266 5.84829 11.1266C5.5505 11.1266 5.37522 11.2108 5.21879 11.331L4.39517 10.1768L5.8841 8.63196H4.06346V7.00293H7.93278V8.63196L6.68887 9.8322V9.86025C7.79143 9.96244 8.31727 10.8561 8.31727 11.852C8.31727 13.1183 7.32025 14.1322 5.8841 14.1322Z" fill="currentColor"/>
    <path d="M9.15789 13.9818V9.94229C9.14093 7.95058 10.0418 6.85254 11.7136 6.85254C12.8161 6.85254 13.4814 7.40156 13.849 8.19304L12.4561 9.0867C12.2545 8.6018 11.9755 8.48157 11.6514 8.48157C11.1877 8.48157 10.9239 8.79816 10.9239 9.54155V9.68181H13.7698V13.9818H9.15601H9.15789ZM12.0208 12.3247V11.2648H10.9258V12.3247H12.0208Z" fill="currentColor"/>
    <path d="M14.6913 11.385C14.6743 10.7799 14.6743 10.1567 14.6913 9.5696C14.7271 7.95058 15.8033 6.85254 17.3356 6.85254C18.8678 6.85254 19.944 7.95058 19.9874 9.5696C20.0043 10.1567 20.0043 10.7799 19.9874 11.385C19.944 13.014 18.8754 14.1301 17.3356 14.1301C15.7958 14.1301 14.7271 13.014 14.6913 11.385ZM16.495 9.41331C16.4592 10.1106 16.4592 10.846 16.495 11.5453C16.5308 12.0943 16.8192 12.457 17.3356 12.457C17.852 12.457 18.1498 12.0943 18.1856 11.5453C18.2214 10.8279 18.2214 10.0926 18.1856 9.41331C18.1498 8.8743 17.8614 8.50963 17.3356 8.50963C16.8097 8.50963 16.5308 8.8723 16.495 9.41331Z" fill="currentColor"/>
    <path d="M22.2 6.00039C21.2068 6.00039 20.4 5.19366 20.4 4.20039C20.4 3.20712 21.2084 2.40039 22.2 2.40039C23.1917 2.40039 24 3.20712 24 4.20039C24 5.19366 23.1933 6.00039 22.2 6.00039ZM22.2 3.54585C21.8384 3.54585 21.5455 3.83875 21.5455 4.20039C21.5455 4.56203 21.8384 4.85494 22.2 4.85494C22.5617 4.85494 22.8546 4.56203 22.8546 4.20039C22.8546 3.83875 22.5617 3.54585 22.2 3.54585Z" fill="currentColor"/>
    <path d="M12 16.9615V19.7507C5.37333 19.7507 0 17.0897 0 13.8036C0 12.1585 1.34757 10.6698 3.52442 9.59375V10.277C2.96843 10.8761 2.65745 11.5434 2.65745 12.2447C2.65745 14.8135 6.81891 16.9034 12 16.9615Z" fill="currentColor"/>
    <path d="M23.9999 13.8036C23.9999 15.635 22.33 17.2741 19.7027 18.3641L16.4459 16.3644C19.3672 15.5569 21.3424 14.014 21.3424 12.2447C21.3424 11.5434 21.0314 10.8761 20.4754 10.277V9.59375C22.6523 10.6698 23.9999 12.1585 23.9999 13.8036Z" fill="currentColor"/>
    <path d="M16.4649 18.3944L11.2424 15.1885V21.6004L16.4649 18.3944Z" fill="currentColor"/>
  </svg>
`

function createVirtualTourLink(url, label) {
  const link = document.createElement("a")
  link.href = url
  link.target = "_blank"
  link.rel = "noopener"
  link.className = "tf-virtual-tour buttons-default cursor-pointer text-decoration-none"
  link.setAttribute("aria-label", label)
  link.innerHTML = `${VIRTUAL_TOUR_360_ICON}<span class="tf-virtual-tour__label">${label}</span>`
  return link
}

function addVirtualTourBtn() {
  const url = getVirtualTourUrl(window.lihe?.id)
  if (!url) return

  const label = window.content?.["gallery_virtualTour"] ?? "Virtual Tour"
  const isMobile = window.screenSizeManager.screenType !== "desktop"

  if (!isMobile) {
    const mainTile = document.querySelector('.gallery-tile[style*="main"]')
    if (mainTile && !mainTile.querySelector(".tf-virtual-tour")) {
      mainTile.classList.add("position-relative")
      const link = createVirtualTourLink(url, label)
      link.id = "tf-virtual-tour"
      mainTile.appendChild(link)
    }
  }

  if (isMobile) {
    const mobileWrapper = document.querySelector(
      "#tf-gallerie-slider-mobile .mobile-slider-wrapper"
    )
    if (mobileWrapper && !mobileWrapper.querySelector(".tf-virtual-tour")) {
      const link = createVirtualTourLink(url, label)
      link.id = "tf-virtual-tour-mobile"
      mobileWrapper.appendChild(link)
    }
  }
}